import { isHotpads } from '@zg-rentals/multibrand-support';
import type { Brand } from '@zg-rentals/multibrand-support';
import StringConstants from '../constants/StringConstants';

export const ACTIVE_ZILLOW_THEME = 'zillow';
export const ACTIVE_HOTPADS_THEME = 'legacy-zillow';

export default function getPandaThemeAttributes(brand: Brand): Record<string, string | undefined> {
  const hotpads = isHotpads(brand);

  return {
    'data-panda-theme': hotpads ? ACTIVE_HOTPADS_THEME : ACTIVE_ZILLOW_THEME,
    'data-panda-theme-customized': hotpads ? StringConstants.UNFORMATTED_BRAND_NAMES.hotpads : undefined,
  };
}
